module.exports = __webpack_public_path__ + "static/media/klocka.3be4f72d.mp3";